import PaginationModel from 'src/model/modules/pagination.model';

const moduleSel = (state: any): PaginationModel => state.pagination;

export const pageNumberSel = (state: any) => moduleSel(state).pageNumber;
export const pageSizeSel = (state: any) => moduleSel(state).pageSize;
export const totalElementsSel = (state: any) => moduleSel(state).totalElements;
export const totalPagesSel = (state: any) => moduleSel(state).totalPages;
